<template>
    <div class="bulk-send-page">
        <!-- 搜索条件 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <el-form-item label="接收号码">
                    <el-input v-model="searchForm.smsTo" placeholder="请输入手机号" clearable></el-input>
                </el-form-item>
                <el-form-item label="发送状态">
                    <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
                        <el-option label="等待发送" value="waiting"></el-option>
                        <el-option label="已发送" value="sent"></el-option>
                        <el-option label="发送失败" value="failed"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="handleSearch" class="search-btn">搜索</el-button>
                    <el-button @click="handleReset" class="reset-btn">重置</el-button>
                </el-form-item>
            </el-form>
        </div>

        <!-- 批量发送记录列表 -->
        <div class="records-section">
            <div class="section-title">
                <h3>发送记录</h3>
                <el-button type="primary" @click="showSendForm" class="add-btn">
                    <i class="el-icon-plus"></i> 新建任务
                </el-button>
            </div>
            <el-table :data="sendRecords" style="width: 100%" class="custom-table">
                <el-table-column label="创建时间" width="180">
                    <template slot-scope="scope">
                        {{ formatDateTime(scope.row.createTime) }}
                    </template>
                </el-table-column>
                <el-table-column label="发送时间" width="180">
                    <template slot-scope="scope">
                        {{ scope.row.sendTime || '-' }}
                    </template>
                </el-table-column>
                <el-table-column prop="content" label="发送内容" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.content }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="smsTo" label="接收号码" width="120" />
                <el-table-column prop="smsFrom" label="发送号码" width="120" />
                <el-table-column prop="status" label="状态" width="100">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)" class="status-tag">
                            {{ getStatusText(scope.row.status) }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="failReason" label="失败原因" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 'failed'" class="error-text">
                            {{ scope.row.failReason }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页 -->
            <div class="pagination-container">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page.current"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="page.size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="page.total"
                    class="custom-pagination">
                </el-pagination>
            </div>
        </div>

        <!-- 批量发送表单弹窗 -->
        <el-dialog title="批量发送消息" :visible.sync="dialogVisible" width="500px" custom-class="custom-dialog">
            <el-form :model="form" label-width="120px">
                <el-form-item label="手机号文件" required>
                    <div class="upload-container">
                        <el-upload class="upload-demo" accept=".txt" action="#" :auto-upload="false" :show-file-list="false"
                            :on-change="handlePhoneFileChange" :before-upload="beforeUpload">
                            <el-button size="small" type="primary" class="upload-btn">
                                <i class="el-icon-upload2 upload-icon"></i>
                                选择手机号文件
                            </el-button>
                        </el-upload>
                        <span v-if="phoneFile" class="file-name">
                            <i class="el-icon-document"></i>
                            {{ phoneFile.name }}
                        </span>
                    </div>
                    <div class="file-desc">必须是txt格式，每行一个手机号</div>
                </el-form-item>
                
                <el-form-item label="消息内容文件">
                    <div class="upload-container">
                        <el-upload class="upload-demo" accept=".txt" action="#" :auto-upload="false" :show-file-list="false"
                            :on-change="handleMessageFileChange" :before-upload="beforeMessageUpload">
                            <el-button size="small" type="info" class="upload-btn message-upload-btn">
                                <i class="el-icon-upload2 upload-icon"></i>
                                选择消息内容文件
                            </el-button>
                        </el-upload>
                        <span v-if="messageFile" class="file-name">
                            <i class="el-icon-document"></i>
                            {{ messageFile.name }}
                        </span>
                    </div>
                    <div class="file-desc">文本文件，每行一条消息，发送时随机选择一条。如不上传，使用系统预设消息</div>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" class="cancel-btn">取消</el-button>
                <el-button type="primary" @click="submitFiles" class="submit-btn" :loading="submitLoading">确定发送</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: 'BulkSendPage',
    data() {
        return {
            dialogVisible: false,
            form: {},
            phoneFile: null,
            messageFile: null,
            sendRecords: [],
            page: {
                current: 1,
                size: 10,
                total: 0
            },
            timer: null,
            searchForm: {
                smsTo: '',
                status: ''
            },
            submitLoading: false
        }
    },
    created() {
        this.fetchSendRecords()
        this.startAutoRefresh()
    },
    beforeDestroy() {
        this.stopAutoRefresh()
    },
    methods: {
        showSendForm() {
            this.dialogVisible = true
            this.phoneFile = null
            this.messageFile = null
        },
        formatDateTime(date) {
            if (!date) return '-'
            const d = new Date(date)
            return d.toLocaleString()
        },
        getStatusType(status) {
            const types = {
                'waiting': 'info',
                'sent': 'success',
                'failed': 'danger'
            }
            return types[status] || 'info'
        },
        getStatusText(status) {
            const texts = {
                'waiting': '等待发送',
                'sent': '已发送',
                'failed': '失败'
            }
            return texts[status] || status
        },
        fetchSendRecords() {
            this.$http.get('/sms/bulk/list', {
                params: {
                    pageNum: this.page.current,
                    pageSize: this.page.size,
                    smsTo: this.searchForm.smsTo,
                    status: this.searchForm.status
                }
            }).then(res => {
                if (res.code === 200) {
                    this.sendRecords = res.rows
                    this.page.total = res.total
                }
            })
        },
        handlePhoneFileChange(file) {
            this.phoneFile = file.raw
        },
        handleMessageFileChange(file) {
            this.messageFile = file.raw
        },
        beforeUpload(file) {
            const isTxt = file.type === 'text/plain'
            if (!isTxt) {
                this.$message.error('只能上传txt文件')
            }
            return isTxt
        },
        beforeMessageUpload(file) {
            const isTxt = file.type === 'text/plain'
            if (!isTxt) {
                this.$message.error('只能上传txt文件')
            }
            return isTxt
        },
        submitFiles() {
            if (!this.phoneFile) {
                this.$message.error('请上传手机号文件')
                return
            }

            this.submitLoading = true

            const formData = new FormData()
            formData.append('phoneFile', this.phoneFile)
            
            // 如果有消息内容文件，则一起上传
            if (this.messageFile) {
                formData.append('messageFile', this.messageFile)
            }

            this.$http.post('/sms/bulk/broadcast', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(res => {
                if (res.code === 200) {
                    this.$message.success('批量发送任务已创建')
                    this.dialogVisible = false
                    this.fetchSendRecords()
                    this.startAutoRefresh()
                } else {
                    this.$message.error(res.msg || '创建任务失败')
                }
            }).catch(err => {
                this.$message.error('创建任务失败: ' + (err.message || '未知错误'))
            }).finally(() => {
                this.submitLoading = false
            })
        },
        handleSizeChange(val) {
            this.page.size = val
            this.fetchSendRecords()
        },
        handleCurrentChange(val) {
            this.page.current = val
            this.fetchSendRecords()
        },
        startAutoRefresh() {
            this.timer = setInterval(() => {
                this.fetchSendRecords()
            }, 3000)
        },
        stopAutoRefresh() {
            if (this.timer) {
                clearInterval(this.timer)
                this.timer = null
            }
        },
        handleSearch() {
            this.page.current = 1
            this.fetchSendRecords()
        },
        handleReset() {
            this.searchForm = {
                smsTo: '',
                status: ''
            }
            this.handleSearch()
        }
    }
}
</script>

<style lang="scss" scoped>
.bulk-send-page {
    box-sizing: border-box;
    padding: 20px;
    height: 100%;
    width: 100%;
    overflow-y: auto;
    background: linear-gradient(135deg, #f6f8fc 0%, #eef1f8 100%);

    .search-section {
        background: white;
        padding: 20px;
        border-radius: 16px;
        margin-bottom: 20px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .search-form {
            .el-form-item {
                margin-bottom: 0;
            }
        }

        :deep(.el-input__inner) {
            border-radius: 12px;
            border: 1px solid #e0e7ff;
            box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
            transition: all 0.3s;

            &:focus {
                border-color: #7366ff;
                box-shadow: 0 0 0 2px rgba(115, 102, 255, 0.2);
            }
        }

        :deep(.el-select .el-input.is-focus .el-input__inner) {
            border-color: #7366ff;
        }

        :deep(.el-button) {
            border-radius: 12px;
            padding: 10px 20px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            font-weight: 500;
        }

        .search-btn {
            background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
            border: none;
            box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
            }

            &:active {
                transform: translateY(0);
                box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
            }
        }

        .reset-btn {
            background: #f8f9fa;
            border: 1px solid #e5e7eb;
            color: #4a5568;

            &:hover {
                background: #e9ecef;
                transform: translateY(-2px);
            }

            &:active {
                transform: translateY(0);
            }
        }
    }

    .section-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;

        h3 {
            margin: 0;
            color: #1e293b;
            font-size: 18px;
            font-weight: 600;
            position: relative;
            padding-left: 12px;

            &::before {
                content: '';
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 4px;
                height: 18px;
                background: linear-gradient(to bottom, #7366ff, #a388ff);
                border-radius: 2px;
            }
        }

        .add-btn {
            background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
            border: none;
            border-radius: 12px;
            padding: 10px 20px;
            font-weight: 500;
            box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

            i {
                margin-right: 4px;
            }

            &:hover {
                transform: translateY(-2px);
                box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
            }

            &:active {
                transform: translateY(0);
                box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
            }
        }
    }

    .records-section {
        background: white;
        padding: 20px;
        border-radius: 16px;
        box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);

        .custom-table {
            margin-bottom: 20px;
            border-radius: 12px;
            overflow: hidden;

            :deep(.el-table__header-wrapper) {
                th {
                    background: #f6f9fc;
                    color: #1e293b;
                    font-weight: 600;
                    padding: 12px 0;
                }
            }

            :deep(.el-table__body-wrapper) {
                td {
                    padding: 12px 0;
                    color: #4a5568;
                }
            }

            :deep(.el-table--enable-row-hover .el-table__body tr:hover > td) {
                background-color: #f8f9ff;
            }

            :deep(.el-table__row) {
                transition: all 0.3s;
            }

            :deep(.el-table--striped .el-table__body tr.el-table__row--striped td) {
                background: #f9fafc;
            }
        }

        .status-tag {
            border-radius: 8px;
            padding: 4px 8px;
            font-weight: 500;
            border: none;
            &.el-tag {
                height: auto;
            }

            &.el-tag--info {
                background: rgba(96, 165, 250, 0.1);
                color: #3b82f6;
            }

            &.el-tag--success {
                background: rgba(34, 197, 94, 0.1);
                color: #22c55e;
            }

            &.el-tag--danger {
                background: rgba(244, 63, 94, 0.1);
                color: #f43f5e;
            }
        }

        .pagination-container {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;

            .custom-pagination {
                :deep(.el-pagination__total) {
                    color: #4a5568;
                }

                :deep(.el-pagination__sizes) {
                    margin-left: 16px;
                }

                :deep(.el-input__inner) {
                    border-radius: 8px;
                }

                :deep(.el-pager li) {
                    border-radius: 8px;
                    margin: 0 3px;
                    transition: all 0.3s;
                }

                :deep(.el-pager li.active) {
                    background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
                    color: white;
                    box-shadow: 0 2px 5px rgba(115, 102, 255, 0.3);
                }

                :deep(.btn-prev, .btn-next) {
                    border-radius: 8px;
                }
            }
        }
    }
}

.error-text {
    color: #f43f5e;
    font-size: 13px;
    display: flex;
    align-items: center;

    &::before {
        content: '\26A0';
        margin-right: 5px;
        color: #f43f5e;
    }
}

.upload-container {
    display: flex;
    align-items: center;
    gap: 12px;

    .upload-btn {
        background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
        border: none;
        border-radius: 10px;
        padding: 10px 16px;
        box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        display: flex;
        align-items: center;
        gap: 6px;

        &.message-upload-btn {
            background: linear-gradient(135deg, #36C3FF 0%, #42a6f5 100%);
            box-shadow: 0 4px 10px rgba(54, 195, 255, 0.3);
            
            &:hover {
                box-shadow: 0 6px 15px rgba(54, 195, 255, 0.4);
            }
            
            &:active {
                box-shadow: 0 4px 10px rgba(54, 195, 255, 0.3);
            }
        }

        .upload-icon {
            font-size: 16px;
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
        }

        &:active {
            transform: translateY(0);
            box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
        }
    }

    .file-name {
        display: flex;
        align-items: center;
        padding: 6px 12px;
        background: #f8f9fa;
        border-radius: 8px;
        color: #4a5568;
        font-size: 14px;
        
        i {
            margin-right: 6px;
            color: #7366ff;
        }
    }
}

.file-desc {
    font-size: 12px;
    color: #6b7280;
    margin-top: 4px;
    padding-left: 2px;
}

.custom-input-number {
    :deep(.el-input__inner) {
        border-radius: 10px;
        border: 1px solid #e0e7ff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.02);
        transition: all 0.3s;

        &:focus {
            border-color: #7366ff;
            box-shadow: 0 0 0 2px rgba(115, 102, 255, 0.2);
        }
    }

    :deep(.el-input-number__increase, .el-input-number__decrease) {
        border-radius: 0 10px 0 0;
        border-left: 1px solid #e0e7ff;
        color: #7366ff;
        
        &:hover {
            background-color: #f0f4ff;
        }
    }

    :deep(.el-input-number__decrease) {
        border-radius: 0 0 10px 0;
    }
}
</style>

<style>
.custom-dialog .el-dialog__header {
    background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
    padding: 16px 20px;
    position: relative;
}

.custom-dialog .el-dialog__title {
    color: white;
    font-weight: 600;
}

.custom-dialog .el-dialog__headerbtn {
    position: absolute;
    top: 16px;
    right: 16px;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
    color: rgba(255, 255, 255, 0.8);
}

.custom-dialog .el-dialog__headerbtn:hover .el-dialog__close {
    color: white;
}

.custom-dialog .el-dialog__body {
    padding: 24px;
}

.custom-dialog .el-dialog__footer {
    border-top: 1px solid #f0f0f0;
    padding: 16px 20px;
}

.custom-dialog .dialog-footer .cancel-btn {
    background: #f8f9fa;
    border: 1px solid #e5e7eb;
    color: #4a5568;
    border-radius: 10px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    padding: 10px 20px;
}

.custom-dialog .dialog-footer .cancel-btn:hover {
    background: #e9ecef;
    transform: translateY(-2px);
}

.custom-dialog .dialog-footer .submit-btn {
    background: linear-gradient(135deg, #7366ff 0%, #a388ff 100%);
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.custom-dialog .dialog-footer .submit-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 15px rgba(115, 102, 255, 0.4);
}

.custom-dialog .dialog-footer .submit-btn:active {
    transform: translateY(0);
    box-shadow: 0 4px 10px rgba(115, 102, 255, 0.3);
}

.custom-dialog .el-dialog {
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.1);
}
</style>